<div class="info-widget" [ngClass]="{ 'p-0': noPadding }">
  <h3 class="t-bold">{{ heading }}</h3>
  <p>{{ description }}</p>
  <div class="extra">
    @if (!hideActionBtn && actionBtn) {
    <un-button
      type="primary"
      size="large"
      [link]="actionBtnLink"
      [queryParams]="actionBtnQuery"
      (click)="actionBtnClicked.emit()"
      >{{ actionBtn }}</un-button
    >
    } @if (link) {
    <a
      class="t-medium t-large"
      [routerLink]="link"
      [queryParams]="actionBtnQuery"
      [ngClass]="linkClass"
      >{{ linkText }}</a
    >
    }
  </div>
</div>
